export const Constant = {
  MAX_APP_WIDTH: 1440,
  MOBILE_BREAK_WIDTH: 768,
} as const;
